import React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { login } from '../services/auth';

export default function LoginPage() {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom>
            Nupis Campus Portal
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center">
            Schulungsverwaltung für CAM und BIM Trainings
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<LoginIcon />}
            onClick={login}
            sx={{ mt: 2 }}
          >
            Mit Azure AD anmelden
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}
